import React, { useEffect, useState } from "react";
import { images } from "../../Images/Svg";
import Grid from "@mui/material/Grid";
import style from "./LoginPage.module.css";
import PersonIcon from "@mui/icons-material/Person";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import CommonInput from "../../CommonComponents/CommonInput";
import CommonButton from "../../CommonComponents/CommonButton";
import Navigation from "../../Layouts/Navigation/Navigation";
import { useNavigate } from "react-router-dom";
import { userLogin } from "../../Services/login.service";
import { useDispatch, useSelector } from "react-redux";
import { saveToken, userDataReducer } from "../../Redux/Slice/loginSlice";
import useToaster from "../../customHook/useToaster";
import { analyticsEvent } from "../../Utils/helper";
import { decrypt, encrypt } from "../../Encryption/encryption";
const { loginIcon, chaseLogo } = images;

const LoginPage = () => {
  const [userMailId, setUserMaliId] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [showPassword, setShowPassword] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = useToaster();
  const { token: isAuthenticated } = useSelector((state) => state.loginSlice);
  //email address validations function
  function validate(email) {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!reg.test(email)) {
      return false;
    } else {
      return true;
    }
  }

  const onClickHandler = () => {
    setShowPassword((prev) => !prev);
  };

  const onSubmit = () => {
    if (!userMailId?.length) {
      return showToast("Please enter Username or Email", "error", true);
    } else if (!userPassword?.length) {
      return showToast("Please enter password", "error", true);
    }
    let payload = {
      email: validate(userMailId)
        ? userMailId
        : userMailId + process.env.REACT_APP_USERNAME_EXT,
      password: userPassword,
    };
    let body = {
      data: encrypt(JSON.stringify(payload)),
    };
    userLogin(body)
      .then((data) => {
        if (data?.success) {
          let decryptData = JSON.parse(decrypt(data.data));
          //Google Analytics Event to Track User Login
          analyticsEvent(
            "User Login",
            "Login Success",
            `${decryptData?.currentRoleName} Login`
          );
          showToast("Logged in successfully", "success", true);
          dispatch(userDataReducer(decryptData));
          dispatch(saveToken(decryptData?.token));
          navigate("/home");
        }
      })
      .catch((err) =>
        showToast(
          err?.response?.data?.message || "something went wrong!",
          "error",
          true
        )
      );
  };

  // useEffect(() => {
  //   dispatch({ type: "USER_LOGOUT" });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  const handleKeyPress = (e) => {
    if (e?.key === "Enter") {
      e.preventDefault();
      onSubmit();
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (localStorage.getItem("isTourRunnig") === null) {
      localStorage.setItem("isTourRunnig", true);
      localStorage.setItem("activeTourStep", 0);
    }
  }, []);

  return (
    <>
      <Navigation disabled boxShadow={false} />
      <div className={style["main_conatiner"]} onKeyDown={handleKeyPress}>
        <Grid container rowSpacing={1}>
          <Grid
            sx={{
              marginTop: "calc(8.5% - 32px)",
            }}
            md={6}
            sm={12}
            xs={12}
            item
          >
            <div style={{ textAlign: "center" }}>
              <img src={chaseLogo} alt="chaseLogo" />
            </div>
            <div className={style["img_div"]}>
              <img src={loginIcon} alt="login" />
            </div>
          </Grid>
          <Grid
            md={6}
            sm={12}
            xs={12}
            sx={{
              border: "1px solid #E8E8E8",
              marginTop: { xs: "1.6rem", md: "calc(8.5% - 32px)" },
              borderRadius: "25px",
            }}
            item
          >
            <div style={{ padding: "2rem" }}>
              <h4>LOGIN</h4>
              <div className={style["input_div"]}>
                <CommonInput
                  placeholder={"Enter Username"}
                  filled
                  icon={
                    <PersonIcon sx={{ fontSize: "2.5rem", color: "white" }} />
                  }
                  onChange={(e) => setUserMaliId(e?.target?.value?.trim())}
                />
              </div>
              <div className={style["input_div"]}>
                <CommonInput
                  placeholder={"Enter Password"}
                  password
                  showPassword={showPassword}
                  filled
                  onClick={onClickHandler}
                  passwordIconOff={
                    <LockOutlinedIcon
                      sx={{ fontSize: "2.5rem", color: "white" }}
                    />
                  }
                  passwordIcon={
                    <LockOpenOutlinedIcon
                      sx={{ fontSize: "2.5rem", color: "white" }}
                    />
                  }
                  onChange={(e) => setUserPassword(e?.target?.value?.trim())}
                />
              </div>
              <p className={style["password_tag"]}>
                <a
                  href="https://pssm.hdfcergo.com/authorization.do"
                  target="target_blank"
                >
                  Forgot Password?
                </a>
              </p>
              <div className={style["btn_div"]}>
                <CommonButton
                  largeButton
                  filledButton
                  boxShadow
                  label="Login"
                  uppercase
                  onClick={onSubmit}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default LoginPage;
